import { useState } from "react";
import SpaceShooter from "./games/SpaceShooter";
import Snake from "./games/Snake";
import Tetris from "./games/Tetris";

const games = [
	{
		id: "space",
		name: "Space Shooter",
		component: SpaceShooter,
		icon: "🚀",
	},
	{
		id: "snake",
		name: "Snake",
		component: Snake,
		icon: "🐍",
	},
	{
		id: "tetris",
		name: "Tetris",
		component: Tetris,
		icon: "🎮",
	},
];

const GameCenter = () => {
	const [selectedGame, setSelectedGame] = useState(games[0].id);

	const CurrentGame = games.find((game) => game.id === selectedGame)?.component;

	return (
		<div className='space-y-4'>
			<div className='flex gap-2'>
				{games.map((game) => (
					<button
						key={game.id}
						onClick={() => setSelectedGame(game.id)}
						className={`px-4 py-2 rounded-full font-bold transition-colors ${
							selectedGame === game.id
								? "bg-trump-yellow text-black"
								: "bg-white/10 text-white hover:bg-white/20"
						}`}>
						<span className='mr-2'>{game.icon}</span>
						{game.name}
					</button>
				))}
			</div>
			{CurrentGame && <CurrentGame />}
		</div>
	);
};

export default GameCenter;
